import { render, staticRenderFns } from "./switch.vue?vue&type=template&id=5277d3a8&"
import script from "./switch.vue?vue&type=script&lang=ts&"
export * from "./switch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports